import React, {Fragment} from "react";
import DropdownComponent from "./DropdownComponent";
import UtilityProvinceList from "../services/utility/UtilityProvinceList";

export default class ProvinceDropdownComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      provinceList: []
    };

    this.onProvinceListLoaded = this.onProvinceListLoaded.bind(this)
  }

  componentDidMount() {
    UtilityProvinceList.retrieveProvinceList(this.onProvinceListLoaded);
  }

  onProvinceListLoaded(provinceList) {
    this.setState({
      provinceList: provinceList
    })
  }

  render() {
    return <Fragment>{
      UtilityProvinceList.PROVINCE_LIST === null ? <Fragment>Loading...</Fragment>
        : <DropdownComponent
          optionText={"displayName"}
          optionValue={"value"}
          {...this.props}
          options={this.state.provinceList}
        />
    }
    </Fragment>
  }

}
